export enum RequestType {
  Mint = 'Mint',
  Burn = 'Burn',
}

export enum RequestState {
  Offered = 'Offered',
  Failed = 'Failed',
  Rejected = 'Rejected',
  Executed = 'Executed',
  Requested = 'Requested',
}

export interface RowNew {
  contractId: string;
  instrumentId: string;
  createdAt: string;
  reason?: string;
  receiver: string;
  sender: string;
  operator: string;
  provider: string;
  registrar: string;
  amount: string;
  reference?: string;
  requestType: RequestType;
  requestState: RequestState;
  executeBefore?: string;
  isThreeStep?: boolean;
  holdingLabel?: string;
}
